<template>
    <span class="badge badge-secondary">
        <slot></slot>
        <i class="fas fa-times fa-fw action" @click="dismissClicked"></i>
    </span>
</template>

<script>
export default {
    name: "Pill",
    methods: {
        dismissClicked: function() {
            this.$emit('dismissAction');
        }
    }
}
</script>

<style lang="scss" scoped>
    $border-radius: 5px;
.badge {
    background-color: $primary-color !important;
    padding: 10px;
    margin: 3px;
    font-size: 14px;
    font-weight: 400;
    border-radius: $border-radius;
}

.action {
    margin-left: 5px;
    background-color: $primary-color;
    border-radius: $border-radius;
    color: $white !important;
    cursor: pointer;

}
</style>